module.exports = __webpack_public_path__ + "img/recover_short.4daa19f0.png";